// Save-path merge for the Roles & Responsibilities screen.
//
// The screen renders only the codenames listed in its tab catalog
// (permissionCategories), but a role can hold codenames outside that catalog —
// today the ones struck in V3/B9, and any codename seeded in the future. The
// backend save is a full replace (`role.permissions.set(...)`), so the payload
// must carry the role's un-rendered codenames too; otherwise every save
// silently strips them (e.g. locking a role out of the radar or out of R&R
// itself).
//
// SINCE BE #293 (B10) THIS IS A BELT, NOT THE BRACES. assign_permissions now
// refuses any id outside the club catalogue with a 400 and writes nothing, and
// it carries the role's off-catalogue codenames through by itself
// (`role.permissions.exclude(codename__in=CLUB_PERMISSION_CODENAMES)`). The
// server owns the guarantee; this helper can no longer be the only thing
// standing between a naive save and a silent strip.
//
// The two do NOT fight. The codenames this helper preserves are by definition
// outside the rendered catalogue, and the caller turns codenames into ids by
// intersecting with `availablePermissions` — the response of GET
// available_permissions/, i.e. the catalogue itself. Preserved off-catalogue
// codenames therefore find no id and never reach the payload, so the request
// can never trip the new 400. Kept because it costs nothing and still states
// the intent at the place where the payload is built.

// Every codename the screen renders and therefore owns checkbox state for.
export const catalogCodenames = (permissionCategories) => {
  const keys = new Set();
  Object.values(permissionCategories).forEach((permissionList) => {
    permissionList.forEach((permission) => keys.add(permission.key));
  });
  return keys;
};

// Full codename set to save for one role: the role's existing codenames the
// screen does not render (preserved as-is), plus the catalog codenames whose
// checkbox is currently checked. Catalog codenames are NOT seeded from the
// role, so unchecking one still removes it.
export const buildRolePermissionCodenames = (
  role,
  permissionCategories,
  permissionsState
) => {
  const catalog = catalogCodenames(permissionCategories);

  const codenames = new Set(
    (role.permission_codenames || []).filter(
      (codename) => !catalog.has(codename)
    )
  );

  Object.keys(permissionCategories).forEach((tabId) => {
    permissionCategories[tabId].forEach((permission) => {
      if (permissionsState[tabId]?.[role.id]?.[permission.key]) {
        codenames.add(permission.key);
      }
    });
  });

  return codenames;
};
